import React from "react";
import styles from "../css/style";
import { Navbar, Footer } from "../components/LandingPage";

const Indhold = () => {
  return (
    <>
      <div className={`${styles.paddingX} ${styles.flexCenter} w-full overflow-hidden`}>
        <div className={`${styles.boxWidth}`}>
          {/* Navbar with onlyAuth prop to display Log ind and Opret bruger */}
          <Navbar onlyAuth />
        </div>
      </div>
      <div className="bg-primary w-full overflow-hidden pt-[150px]">
        <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
          <div className={`${styles.boxWidth}`}>
            <h1 className="text-3xl font-bold mb-6 text-white">Indhold</h1>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>
                Facebook:{" "}
                <a
                  href="https://www.facebook.com/profile.php?id=61570577011530"
                  className="underline text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  facebook.com/investorverden
                </a>
              </li>
              <li>
                Instagram:{" "}
                <a
                  href="https://www.instagram.com/investorverden/"
                  className="underline text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  instagram.com/investorverden
                </a>
              </li>
              <li>
                Youtube:{" "}
                <a
                  href="https://www.youtube.com/@Investorverden"
                  className="underline text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  youtube.com/investorverden
                </a>
              </li>
            </ul>
            <p className="mb-4 text-dimWhite">
              Husk at følge os for at holde dig opdateret på vores seneste indsigt og udviklinger.
            </p>

            {/* Additional Content */}
            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4 text-white">Kontakt Os</h2>
              <p className="mb-4 text-dimWhite">
                Har du spørgsmål eller brug for support? Tøv ikke med at kontakte os!
              </p>
              <ul className="list-disc list-inside mb-4 text-dimWhite">
                <li>Email: <a href="mailto:info@investorverden.dk" className="underline text-white">info@investorverden.dk</a></li>
                <li>Telefon: <a href="tel:+4512345678" className="underline text-white">+45 12 34 56 78</a></li>
                <li>Adresse: <span className="text-white">Investor Verden, Vejnavn 123, 1000 København K</span></li>
              </ul>
            </section>

            {/* Add more sections as needed to fill the page */}

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Indhold;